import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { defaultProfileImage } from "../../../utils/constants";
import { CommunityMediaEnum } from "../enums/CommunityMediaEnum";
import { CommunityDiscussComments } from "../models/CommunityDiscussComments"
import { CommunityMediaIcon } from "./CommunityMediaIcon";
import { CommunityVidePreview } from "./CommunityVidePreview";

type Props = {
    comment: CommunityDiscussComments;
    onReply: () => void;
    onReact: () => void;
}

export const CommunityComment = ({ comment, onReply, onReact }: Props) => {
    const _parseDate = (date: string) => new Date(date)
        .toLocaleString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    return (
        <div className="community-comment">
            <img src={toAbsoluteUrl(comment.avatar) || defaultProfileImage} onError={(e) => { e.currentTarget.src = defaultProfileImage }} alt={comment.author} />
            <div className="community-comment__info">
                <div className="community-comment__info__header">
                    <span className="author">{comment.author}</span>
                    { comment.isMine && (<div className="host"><span>HOST</span></div>) }
                    <span className="dot">•</span>
                    <span className="date">{_parseDate(comment.createdAt)}</span>
                </div>

                {comment.reply && (
                    <div className="community-comment__info__reply">
                        <img src={toAbsoluteUrl(comment.reply.avatar) || defaultProfileImage} onError={(e) => { e.currentTarget.src = defaultProfileImage }} alt={comment.reply.author} />
                        <span className="author">{comment.reply.author}</span>
                        { comment.reply.isMine && (<div className="host"><span>HOST</span></div>) }
                        <span className="content-preview">{comment.reply.content}</span>
                    </div>
                )}

                <div className="community-comment__info__content">
                    {comment.content}
                </div>

                {comment.files && (
                    <div className="community-comment__info__images">
                        { comment.files.map(f => (
                            <>
                                { f.resourceType === CommunityMediaEnum.image ? (
                                    <img style={{ cursor: 'pointer' }} src={toAbsoluteUrl(f.file)} alt={f.title} key={f.id} onClick={() => window.open(f.file, '_blank')} />
                                ): f.resourceType === CommunityMediaEnum.video ? (
                                    <CommunityVidePreview src={toAbsoluteUrl(f.file)} title={f.title}/>
                                ): (
                                    <div style={{ display: 'flex', alignItems: 'center', background: '#f5f5f5', cursor: 'pointer' }} onClick={() => window.open(f.file, '_blank')}>
                                        <CommunityMediaIcon type={f.resourceType} />
                                        <span style={{ paddingRight: '12px', fontSize: 'var(--text-xs)', color: 'var(--color-dark-gray)'  }}> { f.title } </span>
                                    </div>
                                )}
                            </>
                        ))}
                    </div>
                )}

                <div className="community-comment__info__actions">

                    <button onClick={onReply}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6.2417 4.00098L1.12109 9.12158L6.2417 14.2422" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.00049 9H10.0005C16.6279 9 22.0005 14.3726 22.0005 21" stroke="#808080" stroke-linecap="round"/>
                        </svg>
                    </button>

                    <div>
                        <button onClick={onReact} title={comment.isLiked ? "Unlike" : "Like"} className={comment.isLiked ? 'reaction-liked' : ''}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M11.9698 22C17.4926 22 21.9698 17.5228 21.9698 12C21.9698 6.47715 17.4926 2 11.9698 2C6.44688 2 1.96973 6.47715 1.96973 12C1.96973 17.5228 6.44688 22 11.9698 22Z" stroke={comment.isLiked ? "#151515" : "#808080"} fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M7.20996 16C8.25996 17.51 10.02 18.5 12 18.5C13.98 18.5 15.73 17.51 16.79 16" stroke={comment.isLiked ? "#151515" : "#808080"} stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16 11C15.4477 11 15 10.5523 15 10C15 9.44771 15.4477 9 16 9C16.5523 9 17 9.44771 17 10C17 10.5523 16.5523 11 16 11Z" fill={comment.isLiked ? "#151515" : "#808080"}/>
                                <path d="M8 11C7.44773 11 7 10.5523 7 10C7 9.44771 7.44773 9 8 9C8.55227 9 9 9.44771 9 10C9 10.5523 8.55227 11 8 11Z" fill={comment.isLiked ? "#151515" : "#808080"}/>
                            </svg>
                        </button>
                        <span>{comment.reactions}</span>
                    </div>
                </div>

            </div>


        </div>
    )
}